import { catchError } from 'rxjs'
import { map } from 'rxjs/operators'
import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { BaseResponse } from '@services/api/api-base.service'
import { emptyPaginateObservable, Paginate, ofPaginate } from '@models/paginate.model'
import { ManagementApiBaseService } from '@services/api/management-api-base.service'
import {
	SupplierEnrollmentNoticeCounterargumentSearch,
	SupplierEnrollmentNoticeCounterargument,
	SupplierEnrollmentNoticeCounterargumentType
} from '@models/supplier/notice/supplier-enrollment-notice.model'

@Injectable({
	providedIn: 'root'
})
export class SupplierEnrollmentNoticeCounterargumentService extends ManagementApiBaseService<SupplierEnrollmentNoticeCounterargumentSearch> {
	private readonly source: string

	constructor(override http: HttpClient) {
		super(http)
		this.sortColumn = 'createdAt'
		this.source = 'supplier-enrollment-notice-counterarguments'
		this.searchTerm = new SupplierEnrollmentNoticeCounterargumentSearch()
	}

	search(query: SupplierEnrollmentNoticeCounterargumentSearch, params?: HttpParams) {
		return this.post<SupplierEnrollmentNoticeCounterargumentSearch, Paginate<SupplierEnrollmentNoticeCounterargument>>(
			`${this.source}/search`,
			query,
			this.params(params)
		).pipe(
			map(response => ofPaginate(response, SupplierEnrollmentNoticeCounterargument)),
			catchError(() => emptyPaginateObservable<SupplierEnrollmentNoticeCounterargument>())
		)
	}

	searchSupplier(enrollmentId: string, query?: SupplierEnrollmentNoticeCounterargumentSearch, params?: HttpParams) {
		query = query ?? new SupplierEnrollmentNoticeCounterargumentSearch()
		query.enrollmentId = enrollmentId

		return this.post<SupplierEnrollmentNoticeCounterargumentSearch, Paginate<SupplierEnrollmentNoticeCounterargument>>(
			`${this.source}/search`,
			query,
			this.params(params)
		).pipe(
			map(response => ofPaginate(response, SupplierEnrollmentNoticeCounterargument)),
			catchError(() => emptyPaginateObservable<SupplierEnrollmentNoticeCounterargument>())
		)
	}

	counterargument(entity: SupplierEnrollmentNoticeCounterargument) {
		return this.post<SupplierEnrollmentNoticeCounterargument, BaseResponse>(
			`${this.source}/${SupplierEnrollmentNoticeCounterargumentType.COUNTERARGUMENT}/argument`,
			entity
		)
	}

	appeal(entity: SupplierEnrollmentNoticeCounterargument) {
		return this.post<SupplierEnrollmentNoticeCounterargument, BaseResponse>(
			`${this.source}/${SupplierEnrollmentNoticeCounterargumentType.APPEAL}/argument`,
			entity
		)
	}

	granted(id: string, attachmentId: string, description?: string) {
		return this.patch<any>(`${this.source}/${id}/granted`, { attachmentId, description })
	}

	rejected(id: string, attachmentId: string, description?: string) {
		return this.patch<any>(`${this.source}/${id}/rejected`, { attachmentId, description })
	}

	detail(id: string) {
		return this.get<SupplierEnrollmentNoticeCounterargument>(`${this.source}/${id}`).pipe(
			map(response => new SupplierEnrollmentNoticeCounterargument(response))
		)
	}

	sent(id: string) {
		return this.get<boolean>(`${this.source}/${id}/sent`)
	}
}
